export default __webpack_public_path__ + "static/media/00d9de3d51a7c229.9318b86824b7d0813a3e8e7316ee3325.svg";